import React, {Suspense, lazy} from 'react';
import './App.css';
import { BrowserRouter as Router, Redirect, Route, Switch } from "react-router-dom";
import { IntlProvider } from "react-intl";
import { zh_CN } from "./config/locale/zh_CN";
import Header from "./components/header/Header";
import { connect } from 'react-redux';
import SignIn from './pages/signin/SignIn';
import SpecialityNav from './components/specialityNav/SpecialityNav';
import ModalRoot, { MessageRoot } from './components/modal/Modal';
import { IState } from './redux/store';
import Register from './pages/register/Register';
import { log } from 'console';
import Footer from "./components/footer/Footer";
import { Space , Spin } from 'antd';
import { RtProgress } from './pages/rtprogress/RTProgress';
import { ProgressNav } from './pages/progress/nav/ProgressNav';
const UseCenter = lazy(() => import('./pages/useCenter/useCenter'));
const ProjectViewer = lazy(() => import('./components/projectViewer/ProjectViewer'));
const SpecialprojectViewer = lazy(() => import('./components/projectViewer/specialprojectViewer'));


const NewprojectViewer = lazy(() => import('./components/projectViewer/newprojectViewer'));

const NewPage = lazy(() => import('./pages/gis/NewPage'));
const InjectPage = lazy(() => import('./pages/gis/InjectPage'));
const UpdateMessage = lazy(() => import('./pages/UpdateMessage'));
const Download = lazy(() => import('./pages/download/Download'));
const Project = lazy(() => import('./pages/project/Project'));
const Data = lazy(() => import('./pages/dataView/Data'));
const Progress = lazy(() => import('./pages/progress/Progress'));






// function App(props: {
//     userName: string,
//     projectName?: string,
// }) {

//     function checkUserName() {

//         if (!props.userName) {
//             return (
//                 <Redirect to={`/signin`} />
//             )

//         } else {
//             return (
//                 <Redirect to={`/${props.userName}/project`} />
//             )
//         }

//     }
//     return (
//         // 这个翻译似乎弃用了
//         <IntlProvider locale={navigator.language} messages={zh_CN}>
//             <Suspense fallback={<div style={{margin: '100px auto',marginBottom: 20,padding: '30px 50px', textAlign: 'center', background: 'rgba(0, 0, 0, 0.05)', borderRadius: 4}}><Spin size="large" /></div>} >
//             <Router>
//                 {/* 这里是用作全屏显示的，保证footer一直保持在最底部。 */}
//                 <div className="d-flex flex-column min-vh-100">
//                     <Header />
//                     {/* <div className="flex-grow-1 container-fluid row justify-content-center">
//                         <div className="col-md-10"> */}
//                     <Switch>

//                         {/* 登录 */}
//                         <Route path={`/signin`}>
//                             <div className="flex-grow-1 container-fluid row justify-content-center">
//                                 <div className="col-md-10">
//                                     <SignIn />
//                                 </div>
//                             </div>
//                         </Route>

//                         <Route path={`/register`}>
//                             <div className="flex-grow-1 container-fluid row justify-content-center">
//                                 <div className="col-md-10">
//                                     <Register />
//                                 </div>
//                             </div>
//                         </Route>

//                         {/* gis页面，为了去除左侧导航 */}
//                         <Route path={`/${props.userName}/gis`}>
//                             <InjectPage src={process.env.REACT_APP_GIS_ENTRYPOINT} />
//                         </Route>
//                         {/* 用户中心 */}
//                         <Route path={`/${props.userName}/useCenter`}>
//                             {/* <UpdateMessage /> */}
//                             <div className="flex-grow-1 container-fluid row justify-content-center">
//                                 <div className="col-md-11" style={{ marginTop: 80,marginBottom: 100 }}>
//                                     <UseCenter />
//                                 </div>
//                             </div>
//                         </Route>


//                         {/* <Route path={`/${props.userName}/monitor`}>
//                             <ProjectViewer />
//                             {props.projectName ? <NewPage src={process.env.REACT_APP_MONITOR_ENTRYPOINT} /> : null}
//                         </Route> */}

//                         {/* <Route path={`/${props.userName}/design`}>
//                             <InjectPage src={process.env.REACT_APP_DESIGN_ENTRYPOINT} />
//                         </Route> */}

//                         <Route path={`/${props.userName}/design1`}>
//                             <InjectPage src={process.env.REACT_APP_DESIGN_ENTRYPOINT1} />
//                         </Route>

//                         <Route path={`/${props.userName}/download`}>
//                             <UpdateMessage />
//                             <Download />
//                         </Route>



//                         {/* 工区 */}
//                         <Route path={`/${props.userName}/project/:spec`}>
//                             <UpdateMessage />
//                             <div className="flex-grow-1 container-fluid row justify-content-center">
//                                 <div className="col-md-11" style={{ marginTop: 80,marginBottom: 200 }}>
//                                     {/* <ProjectViewer /> */}
//                                     <Project />
//                                 </div>
//                             </div>
//                         </Route>

//                         {/* 数据 */}
//                         <Route path={`/${props.userName}/data/:spec`}>
//                             <UpdateMessage />
//                             <div className="flex-grow-1 container-fluid row justify-content-center">
//                                 <div className="col-md-11" style={{height: '98%', overflow: 'auto',marginBottom: 200}}>
//                                     <ProjectViewer />
//                                     <Data />
//                                 </div>
//                             </div>
//                         </Route>
//                         {/* <Route path={`/${props.userName}/progress/:spec/:tech`}> */}

//                         {/* 实时计算 */}
//                         <Route path={`/${props.userName}/rtprogress`}>
//                             <UpdateMessage />
//                             <RtProgress username={props.userName} />
//                         </Route>


//                         {/* 计算页面，为了去除左侧导航 */}
//                         <Route path={`/${props.userName}/progress/:spec/:tech`}>
//                             <UpdateMessage />
//                             <div className="flex-grow-1 container-fluid row justify-content-center">
//                                 <div className="col-md-11" style={{marginBottom: 200}}>
//                                     <ProjectViewer />
//                                     <Progress />
//                                 </div>
//                             </div>
//                         </Route>

//                         {/* 初始设计的四个页面，都包含左侧导航栏 */}
//                         <Route path={`/${props.userName}/:page`}>
//                             <UpdateMessage />
//                             <div className="flex-grow-1 container-fluid row justify-content-center">
//                                 <div className="col-md-10">

//                                     {/* 当前工区校验，如果用户未选择当前工区则自动跳出警告框，并返回工区页面。 */}
//                                     <ProjectViewer />
//                                     <div className="row">

//                                         {/* 左侧导航栏 */}
//                                         <SpecialityNav className="col-md-2" />
//                                         <div className="col-md-10">
//                                             <Switch>

//                                                 {/* 计算 */}
//                                                 <Route path={`/${props.userName}/progress/:spec`}>
//                                                     <div className="col-md-12" style={{marginBottom: 200}}>
//                                                         <ProgressNav />
//                                                     </div>
//                                                 </Route>

//                                                 {/* 成果展示 */}
//                                                 <Route path={`/${props.userName}/achievement/:spec`}>
//                                                     achievement
//                                                 </Route>
//                                             </Switch>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </Route>

//                         {/* 页面跳转，自动跳转至project页面 */}
//                         <Route path={`/${props.userName ? props.userName : "redirect"}`}>
//                             <Redirect to={`/${props.userName}/project`} />
//                         </Route>

//                         {/* 页面跳转，自动跳转至登录页面 */}
//                         <Route path={"/"}>
//                             {checkUserName()}
//                             {/* {props.userName ? <Redirect to={`/${props.userName}`} /> : <Redirect to={`/signin`} />} */}

//                         </Route>
//                     </Switch>

//                     <Footer />
                    
//                 </div>

//                 {/* 模态窗口传送节点 */}
//                 <ModalRoot />

//                 {/* 警告窗等模态窗口传送节点 */}
//                 <MessageRoot />
//             </Router >
//             </Suspense>
            
//         </IntlProvider >
//     );
// }




function App(props: {
    userName: string,
    projectName?: string,
}) {

    function checkUserName() {
        if (!props.userName) {
            return <Redirect to={`/signin`} />;
        } else {
            return <Redirect to={`/${props.userName}/project`} />;
        }
    }

    return (
        <IntlProvider locale={navigator.language} messages={zh_CN}>
            <Suspense fallback={<div style={{margin: '100px auto',marginBottom: 20,padding: '30px 50px', textAlign: 'center', background: 'rgba(0, 0, 0, 0.05)', borderRadius: 4}}><Spin size="large" /></div>} >
                <Router>
                    <div className="d-flex flex-column min-vh-100">
                        <Switch>
                            {/* 登录页面 - 不显示 Header */}
                            <Route path={`/signin`}>
                                <div >
                                    <div >
                                        <SignIn />
                                    </div>
                                </div>
                            </Route>

                            {/* 注册页面 - 不显示 Header */}
                            {/* <Route path={`/register`}>
                                <div className="flex-grow-1 container-fluid row justify-content-center">
                                    <div className="col-md-10">
                                        <Register />
                                    </div>
                                </div>
                            </Route> */}

                            {/* 其他所有页面 - 显示 Header */}
                            <Route path="/">
                                
                                <Header />
                                
                                <Switch>
                                    {/* gis页面，为了去除左侧导航 */}
                                    <Route path={`/${props.userName}/gis`}>
                                        <InjectPage src={process.env.REACT_APP_GIS_ENTRYPOINT} />
                                    </Route>
                                    
                                    {/* 用户中心 */}
                                    <Route path={`/${props.userName}/useCenter`}>
                                        <div className="flex-grow-1 container-fluid row justify-content-center">
                                            <div className="col-md-11" style={{ marginTop: 80,marginBottom: 50 }}>
                                                <UseCenter />
                                            </div>
                                        </div>
                                    </Route>

                                    <Route path={`/${props.userName}/design1`}>
                                        <InjectPage src={process.env.REACT_APP_DESIGN_ENTRYPOINT1} />
                                    </Route>

                                    <Route path={`/${props.userName}/download`}>
                                        <UpdateMessage />
                                        <Download />
                                    </Route>

                                    {/* 工区 */}
                                    <Route path={`/${props.userName}/project/:spec`}>
                                        <UpdateMessage />
                                        <div className="flex-grow-1 container-fluid row justify-content-center" style={{ background: '#fafafe'}}>
                                            <div className="col-md-11" style={{ marginTop: 30,marginBottom: 50, }}>
                                                <Project />
                                            </div>
                                        </div>
                                    </Route>

                                    {/* 数据 */}
                                    <Route path={`/${props.userName}/data/:spec`}>
                                        <UpdateMessage />
                                        <div className="flex-grow-1 container-fluid row justify-content-center" style={{ background: '#fafafe'}}>
                                            <div className="col-md-11" style={{marginBottom: 50}}>
                                                {/* <ProjectViewer /> */}
                                               <SpecialprojectViewer />

                                                <Data />
                                            </div>
                                        </div>
                                    </Route>

                                    {/* 实时计算 */}
                                    <Route path={`/${props.userName}/rtprogress`}>
                                        <UpdateMessage />
                                        <RtProgress username={props.userName} />
                                    </Route>

                                    {/* 计算页面 */}
                                    <Route path={`/${props.userName}/progress/:spec/:tech`}>
                                        <UpdateMessage />
                                        <div className="flex-grow-1 container-fluid row justify-content-center">
                                            <div className="col-md-11" style={{width: '100%', marginBottom: 50}}>
                                                <SpecialprojectViewer />
                                                <Progress />
                                            </div>
                                        </div>
                                    </Route>

                                    {/* 初始设计的四个页面，都包含左侧导航栏 */}
                                    <Route path={`/${props.userName}/:page`}>
                                        <UpdateMessage />
                                        <div className="flex-grow-1 container-fluid row justify-content-center">
                                            <div className="col-md-10">
                                                <NewprojectViewer />
                                                <div className="row">
                                                    {/* <SpecialityNav className="col-md-2" /> */}
                                                    <div style={{marginTop: 30, }}>
                                                        <Switch>
                                                            <Route path={`/${props.userName}/progress/:spec`}>
                                                                <div className="col-md-12" style={{marginBottom: 50}}>
                                                                    <ProgressNav />
                                                                </div>
                                                            </Route>
                                                            <Route path={`/${props.userName}/achievement/:spec`}>
                                                                achievement
                                                            </Route>
                                                        </Switch>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Route>

                                    {/* 页面跳转，自动跳转至project页面 */}
                                    <Route path={`/${props.userName ? props.userName : "redirect"}`}>
                                        <Redirect to={`/${props.userName}/project`} />
                                    </Route>

                                    {/* 页面跳转，自动跳转至登录页面 */}
                                    <Route path={"/"}>
                                        {checkUserName()}
                                    </Route>
                                </Switch>

                                <Footer />
                                        
                                        
                            </Route>
                        </Switch>

                
                    </div>

                    {/* 模态窗口传送节点 */}
                    <ModalRoot />
                    <MessageRoot />
                </Router>
            </Suspense>
        </IntlProvider>
    );
}



const mapStateToProps = (state: IState) => {
    return {
        userName: state.user.userName,
        projectName: state.project.activeName,
    };
};

export default connect(
    mapStateToProps
)(App);





// import React from 'react';
// import './App.css';
// import { BrowserRouter as Router, Redirect, Route, Switch } from "react-router-dom";
// import { IntlProvider } from "react-intl";
// import { zh_CN } from "./config/locale/zh_CN";
// import Header from "./components/header/Header";
// import { connect } from 'react-redux';
// import SignIn from './pages/signin/SignIn';
// import ProjectViewer from './components/projectViewer/ProjectViewer';
// import SpecialityNav from './components/specialityNav/SpecialityNav';
// import Project from './pages/project/Project';
// import ModalRoot, { MessageRoot } from './components/modal/Modal';
// import Data from './pages/dataView/Data';
// import Progress from './pages/progress/Progress';
// import { ProgressNav } from './pages/progress/nav/ProgressNav';
// import InjectPage from './pages/gis/InjectPage';
// import NewPage from './pages/gis/NewPage';
// import { IState } from './redux/store';
// import Register from './pages/register/Register';
// import Download from './pages/download/Download';
// import UpdateMessage from './pages/UpdateMessage';
// import { RtProgress } from './pages/rtprogress/RTProgress';
// import { log } from 'console';
// import UseCenter from './pages/useCenter/useCenter';
// import Footer from "./components/footer/Footer";
// function App(props: {
//     userName: string,
//     projectName?: string,
// }) {

//     function checkUserName() {
      

//         if (!props.userName) {
//             return (
//                 <Redirect to={`/signin`} />
//             )

//         } else {
//             if (window.location.pathname == '/signin') {
//                 return (
//                     <Redirect to={`/signin`} />
//                 )
//             } else {
//                 return (
//                     <Redirect to={`/${props.userName}/project`} />
//                 )
//             }

//         }

//     }


//     return (
//         // 这个翻译似乎弃用了
//         <IntlProvider locale={navigator.language} messages={zh_CN}>
//             <Router>



//                 {/* 这里是用作全屏显示的，保证footer一直保持在最底部。 */}
//                 <div className="d-flex flex-column min-vh-100">
//                     <Route path={`/signin`}>
//                         <div className="flex-grow-1 container-fluid row justify-content-center">
//                             <div className="flex-grow-1 container-fluid row justify-content-center">
//                                 <SignIn />
//                             </div>
//                         </div>
//                     </Route>


//                     {/* <div className="flex-grow-1 container-fluid row justify-content-center">
//                         <div className="col-md-10"> */}
//                     <Switch>

//                         {/* 登录 */}

//                         <Route path={`/register`}>
//                             <Header />
//                             <div className="flex-grow-1 container-fluid row justify-content-center">
//                                 <div className="col-md-10">
//                                     <Register />
//                                 </div>
//                             </div>
//                         </Route>

//                         {/* gis页面，为了去除左侧导航 */}
//                         <Route path={`/${props.userName}/gis`}>
//                             <Header />
//                             <InjectPage src={process.env.REACT_APP_GIS_ENTRYPOINT} />
//                         </Route>
//                         {/* 用户中心 */}
//                         <Route path={`/${props.userName}/useCenter`}>
//                             <Header />
//                             {/* <UpdateMessage /> */}
//                             <div className="flex-grow-1 container-fluid row justify-content-center">
//                                 <div className="col-md-11" style={{ marginTop: 80, marginBottom: 100 }}>
//                                     <UseCenter />
//                                 </div>
//                             </div>
//                         </Route>


//                         <Route path={`/${props.userName}/monitor`}>
//                             <Header />
//                             <ProjectViewer />
//                             {props.projectName ? <NewPage src={process.env.REACT_APP_MONITOR_ENTRYPOINT} /> : null}
//                         </Route>

//                         {/* <Route path={`/${props.userName}/design`}>
//                             <InjectPage src={process.env.REACT_APP_DESIGN_ENTRYPOINT} />
//                         </Route> */}

//                         <Route path={`/${props.userName}/design1`}>
//                             <Header />
//                             <InjectPage src={process.env.REACT_APP_DESIGN_ENTRYPOINT1} />
//                         </Route>

//                         <Route path={`/${props.userName}/download`}>
//                             <Header />
//                             <UpdateMessage />
//                             <Download />
//                         </Route>



//                         {/* 工区 */}
//                         <Route path={`/${props.userName}/project/:spec`}>
//                             <Header />
//                             <UpdateMessage />
//                             <div className="flex-grow-1 container-fluid row justify-content-center">
//                                 <div className="col-md-11" style={{ marginTop: 80, marginBottom: 200 }}>
//                                     {/* <ProjectViewer /> */}
//                                     <Project />
//                                 </div>
//                             </div>
//                         </Route>

//                         {/* 数据 */}
//                         <Route path={`/${props.userName}/data/:spec`}>
//                             <Header />
//                             <UpdateMessage />
//                             <div className="flex-grow-1 container-fluid row justify-content-center">
//                                 <div className="col-md-11" style={{ height: '98%', overflow: 'auto', marginBottom: 200 }}>
//                                     <ProjectViewer />
//                                     <Data />
//                                 </div>
//                             </div>
//                         </Route>
//                         {/* <Route path={`/${props.userName}/progress/:spec/:tech`}> */}

//                         {/* 实时计算 */}
//                         <Route path={`/${props.userName}/rtprogress`}>
//                             <Header />
//                             <UpdateMessage />
//                             <RtProgress username={props.userName} />
//                         </Route>


//                         {/* 计算页面，为了去除左侧导航 */}
//                         <Route path={`/${props.userName}/progress/:spec/:tech`}>
//                             <Header />
//                             <UpdateMessage />
//                             <div className="flex-grow-1 container-fluid row justify-content-center">
//                                 <div className="col-md-11" style={{ marginBottom: 200 }}>
//                                     <ProjectViewer />
//                                     <Progress />
//                                 </div>
//                             </div>
//                         </Route>

//                         {/* 初始设计的四个页面，都包含左侧导航栏 */}
//                         <Route path={`/${props.userName}/:page`}>
//                             <Header />
//                             <UpdateMessage />
//                             <div className="flex-grow-1 container-fluid row justify-content-center">
//                                 <div className="col-md-10">

//                                     {/* 当前工区校验，如果用户未选择当前工区则自动跳出警告框，并返回工区页面。 */}
//                                     <ProjectViewer />
//                                     <div className="row">

//                                         {/* 左侧导航栏 */}
//                                         <SpecialityNav className="col-md-2" />
//                                         <div className="col-md-10">
//                                             <Switch>

//                                                 {/* 计算 */}
//                                                 <Route path={`/${props.userName}/progress/:spec`}>
//                                                     <div className="col-md-12" style={{ marginBottom: 200 }}>
//                                                         <ProgressNav />
//                                                     </div>
//                                                 </Route>

//                                                 {/* 成果展示 */}
//                                                 <Route path={`/${props.userName}/achievement/:spec`}>
//                                                     achievement
//                                                 </Route>
//                                             </Switch>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </Route>

//                         {/* 页面跳转，自动跳转至project页面 */}
//                         <Route path={`/${props.userName ? props.userName : "redirect"}`}>
//                             <Redirect to={`/${props.userName}/project`} />
//                         </Route>

//                         {/* 页面跳转，自动跳转至登录页面 */}
//                         <Route path={"/"}>
//                             {checkUserName()}
//                             {/* {props.userName ? <Redirect to={`/${props.userName}`} /> : <Redirect to={`/signin`} />} */}

//                         </Route>
//                         <Footer />
//                     </Switch>


//                 </div>

//                 {/* 模态窗口传送节点 */}
//                 <ModalRoot />

//                 {/* 警告窗等模态窗口传送节点 */}
//                 <MessageRoot />
//             </Router >
//         </IntlProvider >
//     );
// }


// const mapStateToProps = (state: IState) => {
//     return {
//         userName: state.user.userName,
//         projectName: state.project.activeName,
//     };
// };

// export default connect(
//     mapStateToProps
// )(App);
